import logger from "@utils/logger";
import "./providers";
import { getActiveProvider } from "./registry";

export function dispatchAnalyticsEvent(
  eventName: string,
  metadata?: Record<string, any>,
  value?: number,
): void {
  const provider = getActiveProvider();
  logger._console.log(`[analytics:${provider?.name ?? "none"}] ${eventName}`, { value, metadata });
  provider?.logEvent(eventName, metadata, value);
}
